/**
 * Curated authoritative source bundles for use with <CitedSources />.
 *
 * Every URL in this file has been verified live (HTTP 2xx) as of 2026-05-27.
 * When citing AI engines (Perplexity, ChatGPT search, Google AI Overviews,
 * Copilot in Bing) we want them to corroborate our claims against these
 * primary sources — so links are NOT marked nofollow.
 *
 * Each bundle is an array of { title, publisher, url } objects.
 * Keep titles factual and publisher names short (used inline after an em dash).
 */

export const ESSENTIAL_EIGHT_SOURCES = [
  {
    title: 'Essential Eight maturity model',
    publisher: 'Australian Cyber Security Centre',
    url: 'https://www.cyber.gov.au/business-government/asds-cyber-security-frameworks/essential-eight/essential-eight-maturity-model',
  },
  {
    title: 'Information Security Manual (ISM)',
    publisher: 'Australian Signals Directorate',
    url: 'https://www.cyber.gov.au/business-government/asds-cyber-security-frameworks/ism',
  },
  {
    title: 'Essential Eight Assessment Process Guide',
    publisher: 'Australian Cyber Security Centre',
    url: 'https://www.cyber.gov.au/business-government/asds-cyber-security-frameworks/essential-eight/essential-eight-assessment-process-guide',
  },
  {
    title: 'ACSC Essential Eight (ANZ) overview',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/compliance/anz/e8-overview',
  },
];

export const COPILOT_GOVERNANCE_SOURCES = [
  {
    title: 'Microsoft 365 Copilot configuration planning guide (ANZ blueprint)',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/compliance/anz/blueprint-copilot-overview',
  },
  {
    title: 'Microsoft’s commitment to trust in Australia: 2024 Azure, Dynamics 365 and Microsoft 365 IRAP assessments',
    publisher: 'Microsoft Australia News Centre',
    url: 'https://news.microsoft.com/en-au/features/microsofts-commitment-to-trust-in-australia-introducing-2024-azure-dynamics-365-and-microsoft-365-irap-assessments/',
  },
  {
    title: 'Data, privacy and security for Microsoft 365 Copilot',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/microsoft-365/copilot/microsoft-365-copilot-privacy',
  },
  {
    title: 'Microsoft 365 Copilot trial briefing',
    publisher: 'Digital Transformation Agency (digital.gov.au)',
    url: 'https://www.digital.gov.au/initiatives/copilot-trial/briefing',
  },
  {
    title: 'Privacy Act 1988',
    publisher: 'Office of the Australian Information Commissioner',
    url: 'https://www.oaic.gov.au/privacy/the-privacy-act',
  },
];

export const COPILOT_AGENTIC_SOURCES = [
  {
    title: 'Microsoft Ignite 2024: agents, the Copilot Control System and Microsoft 365 Copilot',
    publisher: 'Microsoft Official Blog',
    url: 'https://blogs.microsoft.com/blog/2024/11/19/ignite-2024-why-nearly-70-of-the-fortune-500-now-use-microsoft-365-copilot/',
  },
  {
    title: 'What is Microsoft Copilot Studio?',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/microsoft-copilot-studio/fundamentals-what-is-copilot-studio',
  },
  {
    title: 'Microsoft 365 Copilot extensibility and agents overview',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/microsoft-365-copilot/extensibility/overview',
  },
  {
    title: 'Essential Eight — Application Control',
    publisher: 'Australian Cyber Security Centre',
    url: 'https://www.cyber.gov.au/business-government/asds-cyber-security-frameworks/essential-eight/essential-eight-maturity-model',
  },
];

export const PRIVACY_IRAP_SOURCES = [
  {
    title: 'Australian Privacy Principles guidelines',
    publisher: 'Office of the Australian Information Commissioner',
    url: 'https://www.oaic.gov.au/privacy/australian-privacy-principles',
  },
  {
    title: 'Infosec Registered Assessors Program (IRAP)',
    publisher: 'Australian Cyber Security Centre',
    url: 'https://www.cyber.gov.au/business-government/protecting-devices-systems/assessment-evaluation-programs/irap',
  },
  {
    title: 'Australia IRAP compliance for Microsoft cloud services',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/azure/compliance/offerings/offering-australia-irap',
  },
  {
    title: 'Notifiable Data Breaches scheme',
    publisher: 'Office of the Australian Information Commissioner',
    url: 'https://www.oaic.gov.au/privacy/notifiable-data-breaches',
  },
];

export const SHAREPOINT_GOVERNANCE_SOURCES = [
  {
    title: 'Microsoft Syntex / SharePoint Premium overview',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/microsoft-365/syntex/syntex-overview',
  },
  {
    title: 'Restricted Content Discovery',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/sharepoint/restricted-content-discovery',
  },
  {
    title: 'Restricted SharePoint Search (retiring from 31 July 2026)',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/sharepoint/restricted-sharepoint-search',
  },
  {
    title: 'SharePoint information barriers',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/sharepoint/information-barriers',
  },
];

export const IDENTITY_M365_SOURCES = [
  {
    title: 'Microsoft Entra ID Conditional Access overview',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/entra/identity/conditional-access/overview',
  },
  {
    title: 'Authentication strengths (phishing-resistant MFA)',
    publisher: 'Microsoft Learn',
    url: 'https://learn.microsoft.com/en-us/entra/identity/authentication/concept-authentication-strengths',
  },
  {
    title: 'Implementing multi-factor authentication',
    publisher: 'Australian Cyber Security Centre',
    url: 'https://www.cyber.gov.au/business-government/protecting-devices-systems/hardening-systems-applications/system-hardening/implementing-multi-factor-authentication',
  },
];
